import React, { useState, useEffect, useRef } from 'react';
import { Phone, Mail, MessageSquare, ChevronDown } from 'lucide-react';
import useCommonContent from '../hooks/useCommonContent';

const ContactDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useCommonContent();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChat = (e) => {
    e.preventDefault();
    setIsOpen(false);
    if (window.Tawk_API && typeof window.Tawk_API.toggle === 'function') {
      window.Tawk_API.toggle();
    } else if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
    }
  };

  return (
    <div className="relative z-[100]" ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-full font-medium transition-all shadow-md hover:shadow-lg"
      >
        <MessageSquare size={18} />
        <span className="hidden sm:inline">{t('contact.button')}</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-3 w-64 bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 p-2 z-[110] transform origin-top-right animate-in fade-in zoom-in-95 duration-200">
          <a 
            href="tel:+18194524163"
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors group"
          >
            <div className="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full group-hover:scale-110 transition-transform">
              <Phone size={18} />
            </div>
            <div>
              <p className="text-sm font-bold text-slate-800 dark:text-slate-200">{t('contact.callUs')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">(819) 452-41-63</p>
            </div>
          </a>
          <a 
            href="mailto:sales@quebecstore.ca"
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors group"
          >
            <div className="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full group-hover:scale-110 transition-transform">
              <Mail size={18} />
            </div>
            <div>
              <p className="text-sm font-bold text-slate-800 dark:text-slate-200">{t('contact.email')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">sales@quebecstore.ca</p>
            </div>
          </a>
          <button 
            onClick={handleChat}
            className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors group text-left"
          >
            <div className="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full group-hover:scale-110 transition-transform">
              <MessageSquare size={18} />
            </div>
            <div>
              <p className="text-sm font-bold text-slate-800 dark:text-slate-200">{t('contact.chat')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">{t('contact.askAica')}</p>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ContactDropdown;
